
<template>
  <div>
    <CRow  class="justify-content-md-center">
      <CCol sm="8">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 求人管理
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2">
                  <label class="record-label">公開ステータス</label>
                  <CSelect
                    placeholder="公開ステータスを選択してください"
                    :class="{ 'hasError': $v.job.state.$error }"
                    :options="stateOpts"
                    :value.sync="job.state"
                  />

                  <label class="record-label pt-3">求人管理番号</label>
                  <CInput v-model="job.uuid_no" />

                  <label class="record-label pt-3">求人タイトル</label>
                  <CInput placeholder="求人のタイトルを入力してください" :class="{ 'is-invalid': $v.job.title.$error }" v-model.trim="$v.job.title.$model" />

                  <label class="record-label pt-3">法人選択</label>
                  <CSelect
                    :options="orgTypes"
                    :value.sync="job.organization_id"
                  />


                  <label class="record-label pt-3">業種</label>
                  <CSelect
                    placeholder="問題の業種を選択してください"
                    :class="{ 'hasError': $v.job.industry_id.$error }"
                    :options="industryTypes"
                    :value.sync="job.industry_id"
                  />


                  <label class="record-label pt-3">性別</label>
                  <CSelect
                    :options="['男性', '女性', '不問']"
                    :value.sync="job.gender"
                  />

                  <label class="record-label pt-3">年齢(下限)</label>
                  <CSelect
                    :options="ageOpts"
                    :value.sync="job.min_age"
                  />

                  <label class="record-label pt-3">年齢(上限)</label>
                  <CSelect
                    :options="ageOpts"
                    :value.sync="job.max_age"
                  />

                  <label class="record-label pt-3">業務内容</label>
                  <wysiwyg  v-model.trim="$v.job.description.$model"  :class="{ 'is-invalid': $v.job.description.$error }"/>


                  <label class="record-label pt-3">職種</label>
                  <CInput v-model.trim="$v.job.occupation" />

                  <label class="record-label pt-3">給与</label>
                  <CInput placeholder="給与を入力してください" :class="{ 'is-invalid': $v.job.salary.$error }" v-model.trim="$v.job.salary.$model" />

                  <label class="record-label pt-3">勤務時間</label>
                  <CInput placeholder="勤務時間を入力してください" :class="{ 'is-invalid': $v.job.working_hours.$error }" v-model.trim="$v.job.working_hours.$model" />

                  <label class="record-label pt-3">勤務地</label>
                  <CInput placeholder="勤務地を入力してください" :class="{ 'is-invalid': $v.job.location.$error }" v-model.trim="$v.job.location.$model" />

                  <label class="record-label pt-3">仕事内容及びアピールポイント</label>
                  <wysiwyg  v-model="job.descriptioin"/>


                  <label class="record-label pt-3">応募資格</label>
                  <wysiwyg  v-model.trim="$v.job.qualification.$model"  :class="{ 'is-invalid': $v.job.qualification.$error }"/>

                  <label class="record-label pt-3">求める人材</label>
                  <wysiwyg  v-model.trim="$v.job.human_resource.$model"  :class="{ 'is-invalid': $v.job.human_resource.$error }"/>

                  <label class="record-label pt-3">採用人数</label>
                  <CInput  v-model="job.number_of_hires" />

                  <label class="record-label pt-3">独身者・既婚者・不問</label>
                  <CInput  v-model="job.married_type" />

                  <label class="record-label pt-3">日本語レベル</label>
                  <CInput  v-model="job.japanese_level" />

                  <label class="record-label pt-3">希望国籍</label>
                  <CInput placeholder="希望の国籍を入力してください" :class="{ 'is-invalid': $v.job.hope_of_country.$error }" v-model.trim="$v.job.hope_of_country.$model" />

                  <label class="record-label pt-3">学歴</label>
                  <CInput  v-model="job.educational_background" />

                  <label class="record-label pt-3">国外からの応募可否</label>
                  <CInput  v-model="job.apply_from_overseas" />

                  <label class="record-label pt-3">休憩時間</label>
                  <CInput  v-model="job.break_time" />

                  <label class="record-label pt-3">月残業時間</label>
                  <CInput  v-model="job.overtime" />

                  <label class="record-label pt-3">休日</label>
                  <CInput  v-model="job.holiday" />

                  <label class="record-label pt-3">労務管理</label>
                  <CInput  v-model="job.labor_management" />

                  <label class="record-label pt-3">賃金台帳</label>
                  <CInput  v-model="job.wage_ledger" />

                  <label class="record-label pt-3">出勤簿</label>
                  <CInput  v-model="job.attendance_record" />

                  <label class="record-label pt-3">賃金台帳作成担当者</label>
                  <CInput  v-model="job.wage_ledger_creator" />

                  <label class="record-label pt-3">賃金台帳作成方法</label>
                  <CInput  v-model="job.way_create_wage_ledger" />

                  <label class="record-label pt-3">就労時間管理</label>
                  <CInput  v-model="job.working_time_management" />

                  <label class="record-label pt-3">食事関係</label>
                  <CInput  v-model="job.meal_related" />

                  <label class="record-label pt-3">作業着</label>
                  <CInput  v-model="job.work_clothes" />

                  <label class="record-label pt-3">保護具</label>
                  <CInput  v-model="job.protective_equipment" />

                  <label class="record-label pt-3">宿泊施設概要</label>
                  <CInput  v-model="job.accommodation_overview" />

                  <label class="record-label pt-3">宿泊施設場所</label>
                  <CInput  v-model="job.place" />

                  <label class="record-label pt-3">宿泊施設名</label>
                  <CInput  v-model="job.accommodation_name" />

                  <label class="record-label pt-3">宿泊施設所在地</label>
                  <CInput  v-model="job.accommodation_location" />

                  <label class="record-label pt-3">部屋面積</label>
                  <CInput  v-model="job.room" />

                  <label class="record-label pt-3">部屋収容人数</label>
                  <CInput  v-model="job.facility" />

                  <label class="record-label pt-3">徴収費用 水道光熱費</label>
                  <CInput  v-model="job.utility_cost" />

                  <label class="record-label pt-3">徴収費用 通信費</label>
                  <CInput  v-model="job.communication_cost" />


                  <label class="record-label pt-3">募集背景</label>
                  <wysiwyg  v-model.trim="$v.job.background.$model"  :class="{ 'is-invalid': $v.job.background.$error }"/>

                  <label class="record-label pt-3">入社後の流れ</label>
                  <wysiwyg  v-model.trim="$v.job.after_joining.$model"  :class="{ 'is-invalid': $v.job.after_joining.$error }"/>

                  <label class="record-label pt-3">交通アクセス</label>
                  <wysiwyg  v-model.trim="$v.job.access.$model"  :class="{ 'is-invalid': $v.job.access.$error }"/>

                  <label class="record-label pt-3">待遇・福利厚生</label>
                  <wysiwyg  v-model.trim="$v.job.walfare.$model"  :class="{ 'is-invalid': $v.job.walfare.$error }"/>


                  <label class="record-label pt-3 w-100">求人イメージ写真</label>
                  <div id="upload" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event, 'images')">
                      <CRow>
                        <CCol v-for="(img, index) in job['images']" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; "><CButton color="danger" sm class="mt-1 py-0" @click="removeImage(index, 'images')">削除</CButton>
                        </CCol>
                      </CRow>
                      <label for="upload_image" class="button">
                        <p>画像を選択</p><input id="org_images" type="file" name="img" @change="uploadFile($event, 'images')" style="display:none;" accept="image/*">
                      </label>
                      <p>またはここに画像ファイルをドラッグ＆ドロップ</p>
                  </div>

                  <label class="record-label pt-3 w-100">会社外写真</label>
                  <div id="upload" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event, 'outside_office_image')">
                      <CRow>
                        <CCol v-for="(img, index) in job['outside_office_image']" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; "><CButton color="danger" sm class="mt-1 py-0" @click="removeImage(index, 'outside_office_image')">削除</CButton>
                        </CCol>
                      </CRow>
                      <label for="upload_image" class="button">
                        <p>画像を選択</p><input id="org_outside_office_image" type="file" name="img" @change="uploadFile($event, 'outside_office_image')" style="display:none;" accept="image/*">
                      </label>
                      <p>またはここに画像ファイルをドラッグ＆ドロップ</p>
                  </div>

                  <label class="record-label pt-3 w-100">会社内写真</label>
                  <div id="upload" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event, 'within_office_image')">
                      <CRow>
                        <CCol v-for="(img, index) in job['within_office_image']" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; "><CButton color="danger" sm class="mt-1 py-0" @click="removeImage(index, 'within_office_image')">削除</CButton>
                        </CCol>
                      </CRow>
                      <label for="upload_image" class="button">
                        <p>画像を選択</p><input id="org_within_office_image" type="file" name="img" @change="uploadFile($event, 'within_office_image')" style="display:none;" accept="image/*">
                      </label>
                      <p>またはここに画像ファイルをドラッグ＆ドロップ</p>
                  </div>

                  <label class="record-label pt-3 w-100">社員写真</label>
                  <div id="upload" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event, 'employee_image')">
                      <CRow>
                        <CCol v-for="(img, index) in job['employee_image']" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; "><CButton color="danger" sm class="mt-1 py-0" @click="removeImage(index, 'employee_image')">削除</CButton>
                        </CCol>
                      </CRow>
                      <label for="upload_image" class="button">
                        <p>画像を選択</p><input id="org_employee_image" type="file" name="img" @change="uploadFile($event, 'employee_image')" style="display:none;" accept="image/*">
                      </label>
                      <p>またはここに画像ファイルをドラッグ＆ドロップ</p>
                  </div>


                  <label class="record-label pt-3 w-100">寮部屋外写真</label>
                  <div id="upload" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event, 'outside_dormitory_image')">
                      <CRow>
                        <CCol v-for="(img, index) in job['outside_dormitory_image']" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; "><CButton color="danger" sm class="mt-1 py-0" @click="removeImage(index, 'outside_dormitory_image')">削除</CButton>
                        </CCol>
                      </CRow>
                      <label for="upload_image" class="button">
                        <p>画像を選択</p><input id="outside_dormitory_image" type="file" name="img" @change="uploadFile($event, 'outside_dormitory_image')" style="display:none;" accept="image/*">
                      </label>
                      <p>またはここに画像ファイルをドラッグ＆ドロップ</p>
                  </div>

                  <label class="record-label pt-3 w-100">寮部屋内写真</label>
                  <div id="upload" class="form-group commonStyle" v-bind:class="{'styleA':styleA, 'styleB':styleB}" @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadFile($event, 'within_dormitory_image')">
                      <CRow>
                        <CCol v-for="(img, index) in job['within_dormitory_image']" :key="img" md="3" class="px-1 pb-3">
                          <img v-bind:src="img" style="width:100%; "><CButton color="danger" sm class="mt-1 py-0" @click="removeImage(index, 'within_dormitory_image')">削除</CButton>
                        </CCol>
                      </CRow>
                      <label for="upload_image" class="button">
                        <p>画像を選択</p><input id="org_employee_image" type="file" name="img" @change="uploadFile($event, 'within_dormitory_image')" style="display:none;" accept="image/*">
                      </label>
                      <p>またはここに画像ファイルをドラッグ＆ドロップ</p>
                  </div>






                  <center>
                    <CButton v-if="isEdit == false" color="info" class="mt-4"  @click="createJob">作成</CButton>
                    <CButton v-else color="info" class="mt-4"  @click="updateJob">更新</CButton>
                  </center>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue"></script>
<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      job: {
        title: "",
        description: "",
        salary: "",
        location: "",
        working_hours: "",
        employment_form: "契約社員",
        tags: "",
        occupation: "",
        human_resource: "",
        walfare: "",
        access: "",
        state: "",
        images: [],
        outside_office_image: []
      },
      ageOpts: [],
      images: {},
      record_id: this.$route.params.id,
      isEdit: false,
      file: null,
      image_data: null,
      selection_methods: ['正社員', '派遣社員', 'アルバイト'],
      stateOpts: [
        {value: "public", label: "公開"},
        {value: "private", label: "非公開"},
        {value: "draft", label: "下書き"},
      ],
      title: "",
      description: "",
      application_start_datetime: "",
      application_end_datetime: "",
      industryTypes: {},
      orgTypes: [],
      tags: "",
      isVisible: false,
      imgs: [],
      styleA:true,
      styleB:false,
      preview:'',
    }
  },
  validations: {
    job: {
      title: {required, minLength: minLength(4)},
      description: {required},
      after_joining: {required},
      qualification: {required},
      industry_id: {required},
      background: {required},
      salary: {},
      hope_of_country: {},
      location: {},
      working_hours: {},
      employment_form: {},
      tags: {},
      human_resource: {},
      walfare: {},
      access: {},
      state: {required}
    },
  },
  methods: {
    toggle(isVisible) {
      this.isVisible = isVisible
    },
    dragOver() {
      console.log('dragover')
    },
    removeImage: function(i, key) {
      this.job[key].splice(i, 1)
    },
    uploadFile: function(event, key){
        this.styleA = true;
        this.styleB = false;
        const files = event.target.files ? event.target.files : event.dataTransfer.files;
        const file = files[0];
        const reader = new FileReader();
        this.job[key] ||= []
        reader.onload = event => {
            this.preview = event.target.result;
            this.job[key].push(event.target.result)
            console.log(this.job)
        };
        console.log("-----")
        reader.readAsDataURL(file);
        document.getElementById("org_" + key).files = files;
    },
    changeStyle: function(event, flag){
        if(flag=='ok'){
            this.styleA = false;
            this.styleB = true;
        }else{
            this.styleA = true;
            this.styleB = false;
        }
    },
    upload(event) {
      const imageFiles = event.dataTransfer.files
      for (var i = 0; i < imageFiles.length; i++) {
        this.images.push(window.URL.createObjectURL(imageFiles[i]))
      }
      this.isVisible = false
    },
    isImage: function(i) {
        var t = i || ""
        if(t.indexOf("line-sampling") > 0) {
            return true
        } else {
            return false
        }
    },
    changeSelect: function(e, t) {
        this.job[t] = e
    },
    formatData: function(label, d) {
        if(label == "name") {
          return this.record.name
        }
        if(label == "status") {
          return this.states[d]
        }
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    updateJob: function() {
      var im_d = ""
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/jobs/" + this.job.id, {"job": this.job, "profile": this.job.images, "outside_office_image": this.job.outside_office_image})
        .then(() => {
          //this.$noty.success("更新されました")
          this.$router.push("/jobs");

        }).catch(error => {
          console.log(error)
        })
    },
    createJob: function() {

      this.$v.$touch()
      //if (this.$v.$invalid) {
      //  console.log("error")
      //} else {
        var im_d = ""
        if(this.imgs.length != 0) {
          im_d = this.imgs.join(",")
        }
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/jobs", {"job": this.job, "profile": im_d})
          .then(() => {
            this.$router.push("/jobs");
          }).catch(error => {
            console.log(error)
          })
      //}
    }
  },
  mounted() {
    if(this.record_id != undefined) {
      this.isEdit = true
      axios
        .get(process.env.VUE_APP_API_ENDPOINT +  "/jobs/" + this.record_id)
        .then((res) => {
          this.job = res.data
          this.job.images = this.job.images.split(",")
          this.job.outside_office_image = (this.job.outside_office_image == null)? [] : this.job.outside_office_image.split(",")

          this.job.outside_dormitory_image = (this.job.outside_dormitory_image == null)? [] : this.job.outside_dormitory_image.split(",")
          this.job.within_dormitory_image = (this.job.within_dormitory_image == null)? [] : this.job.within_dormitory_image.split(",")
          this.job.employee_image = (this.job.within_dormitory_image == null)? [] : this.job.employee_image.split(",")
          this.job.after_joining = (this.job.after_joining == null)? [] : this.job.after_joining.split(",")
          this.job.within_office_image = (this.job.within_office_image == null)? [] : this.job.within_office_image.split(",")
        }).catch(error => {
          console.log(error)
        })
    }

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/organizations", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          response.data.organizations.forEach((i) => {
            this.orgTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.industryTypes = [{
              value: "",
              label: "",
          }]
          response.data.industries.forEach((i) => {
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
      }).catch(error => {
          console.log(error)
      })
    for(var i=0; i<80;i++) {
      this.ageOpts.push({value: i, label: i})
    }
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
<style scoped lang="scss">

/deep/ .id_image {

}
.image {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-weight: 400;
    line-height: 1.5;
    border: 1px solid;
    border-radius: .25rem;
    color: #768192;
    background-color: #fff;
    border-color: #d8dbe0;
}
.w-60 {
    width: 60%;
}
.w-100 {
    width: 100%;
}

.commonStyle{ padding:30px; text-align:center; margin:10px 0px; width:100%;}
.styleA{border:3px dotted gray;}
.styleB{border:3px dotted rgba(0,200,0,0.7);}
.button{border:1px solid green; padding:3px; border-radius:5px; background-color:white;}
.commonStyle {
  p {
    margin: 0px;
  }
  .button p {color:green; margin: 5px 10px;}
}

</style>
